import { render, staticRenderFns } from "./ItemDetailLink.vue?vue&type=template&id=68ccf97f&scoped=true&"
import script from "./ItemDetailLink.vue?vue&type=script&lang=js&"
export * from "./ItemDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccf97f",
  null
  
)

export default component.exports